module.exports = __webpack_public_path__ + "img/5ab9e92cc3f14a2406fa4d61f06819f3.png";